const middleware = store => next => action => {
  if (action.type === '@@router/LOCATION_CHANGE') {
    window.scrollTo(0, 0)
  }
  return next(action)
}

module.exports = middleware
